<template>
  <div class="c-day-picker">
    <Day v-for="day in days" :key="day" :day="day" @select="onDayClick" />
  </div>
</template>

<script setup>
import { DATES } from '../../constants'
import Day from './Day.vue'

const days = DATES.map(([d, ,]) => new Date(d))

const emit = defineEmits(['select'])
const onDayClick = (day) => {
  emit('select', day)
}
</script>

<style scoped lang="scss">
.c-day-picker {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 40px;
  gap: 1em;
}
</style>
